/**
 * AuthCallback — löser in engångslänken från e-posten och skapar sessionen.
 * Rutt: /auth/callback?token=…
 */
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { AuthShell } from "../components/AuthShell";
import { completeMagicLink } from "../lib/api";

const MESSAGES: Record<string, string> = {
  expired: "Länken har gått ut. Begär en ny så skickar vi en färsk.",
  already_used: "Länken är redan använd. Av säkerhetsskäl fungerar varje länk bara en gång.",
  invalid_token: "Länken är ogiltig. Kontrollera att du klickade på hela länken i mejlet.",
};

export default function AuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false);

  useEffect(() => {
    // StrictMode kör effekter två gånger i utveckling. Engångstoken tål inte
    // att lösas in två gånger, så vi vaktar med en ref.
    if (ran.current) return;
    ran.current = true;

    const token = params.get("token");
    if (!token) {
      setError(MESSAGES.invalid_token);
      return;
    }
    completeMagicLink(token)
      .then(() => navigate("/", { replace: true }))
      .catch((e: unknown) => {
        const raw = e instanceof Error ? e.message : "";
        setError(MESSAGES[raw] || "Kunde inte logga in med den här länken.");
      });
  }, [params, navigate]);

  return (
    <AuthShell>
      <div className="auth-form">
        {error ? (
          <>
            <h2 style={{ fontSize: 20, margin: "0 0 10px" }}>Inloggningen gick inte</h2>
            <p style={{ fontSize: 14, lineHeight: 1.5, color: "#4a4a4a" }}>{error}</p>
            <Link
              to="/login"
              className="auth-btn auth-btn-primary"
              style={{ marginTop: 18, display: "block", textAlign: "center" }}
            >
              Begär en ny länk
            </Link>
          </>
        ) : (
          <p style={{ fontSize: 14, color: "#4a4a4a" }}>Loggar in…</p>
        )}
      </div>
    </AuthShell>
  );
}
